module.exports = __webpack_public_path__ + "img/start_now_image.cd988343.svg";